import React, { useState } from "react";

import { useBreakpoint } from "../../hooks/useBreakpoint";

import TextCardList from "../../components/text-page/textCardList";

export const VIMasterclass = ({
  title,
  description,
  blocks,
  containerClass = "relative w-full flex justify-center overflow-hidden bg-yellow-lighter dark:bg-black-light",
  innerContainerClass = "gvi-container mx-auto pt-12 md:pt-20 pb-12 md:pb-20 tab-content",
  titleClass = "pb-8 md:pb-10 font-light",
  descriptionClass = "py-4 text-base leading-normal text-black-lighter dark:text-gray-darken"
}) => {
  const breakpoint = useBreakpoint();
  const [mobileSliderCount, setNextMobileSlider] = useState(3);

  if (!blocks) return <></>;

  return (
    <section className={containerClass}>
      <div className={innerContainerClass}>
        {title && (
          <h1
            className={titleClass}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        {description && (
          <div
            className={descriptionClass}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        <TextCardList
          articleList={blocks}
          containerClass={"pt-4"}
          innerContainerClass={""}
          paginationBtnContainerClass={"mt-16 hidden md:block"}
          showPagination={breakpoint !== "xs"}
          initialVisibleCount={breakpoint === "xs" ? 3 : 4}
          mobileVisibleCount={breakpoint === "xs" ? mobileSliderCount : 4}
          conditionalSliderOpts={{
            condition: breakpoint === "xs",
            slidesPerView: 1.15,
            spaceBetween: 20,
            centeredSlides: false,
            className: "w-full h-full",
            onSlideChange: (swiperCoreEvent) => {
              const { isEnd } = swiperCoreEvent;
              if (isEnd) {
                setNextMobileSlider((prevState) => prevState + 3);
              }
            }
          }}
        />
      </div>
    </section>
  );
};
